import { inject, injectable } from 'inversify'
import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity/BaseEntity'
import { TYPES } from '@/plugins/cad/module/container/types'
import type { FrameSelect } from '@/plugins/cad/module/core/selector/FrameSelect'
import { Selector } from '@/plugins/cad/module/core/selector/Selector'
import type { EntityDetector } from './entityDetector'
import { EntityFrameSelect } from './entityFrameSelect'

/**
 * CAD 实体选择器，基于 Selector 管理当前选中的实体集合并同步高亮状态。
 */
@injectable()
export class EntitySelector extends Selector<IEntity> {
  @inject(TYPES.EntityDetector)
  protected readonly detector!: EntityDetector

  @inject(TYPES.CADViewManager)
  private readonly viewManager!: CADViewManager

  /**
   * 当实体被选中时调用
   */
  protected onItemSelected(entity: IEntity): void {
    this.highlightEntity(entity, true)
  }

  /**
   * 当实体取消选中时调用
   */
  protected onItemDeselected(entity: IEntity): void {
    this.highlightEntity(entity, false)
  }

  /**
   * 当清除所有选择时调用
   */
  protected onSelectionCleared(cleared: IEntity[]): void {
    this.viewManager.cancelSelectEntity(cleared)
  }

  /** 获取框选实例 */
  protected getFrameSelect(): FrameSelect<IEntity> {
    return new EntityFrameSelect(this.viewManager, this.detector, this)
  }

  /**
   * 高亮/取消高亮实体
   */
  private highlightEntity(entity: IEntity, highlight: boolean): void {
    this.viewManager[highlight ? 'selectEntity' : 'cancelSelectEntity'](entity)
  }
}
